

(function ($) {
    'use strict';
    $(function () {


        if ($('.js-hero-swiper').length) {

            var sliderPause = $('.js-hero-swiper').data('pause');
            var sliderLoop = $('.js-hero-swiper').data('loop');
            var sliderAnimateSpeed = $('.js-hero-swiper').data('animatespeed');
            var slideAutoplay = {
                delay: sliderAnimateSpeed,
            };
            if (sliderPause) {
                slideAutoplay = {
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                    delay: sliderAnimateSpeed,
                };
            }

            const heroSwiper = new Swiper('.js-hero-swiper', {
                loop: sliderLoop,
                pagination: {
                    el: '.js-swiper-pagination',
                    clickable: true,
                },
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                autoplay: slideAutoplay
            });

            const displacementSlider = function (opts) {

                let vertex = `
                    varying vec2 vUv;
                    void main() {
                      vUv = uv;
                      gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
                    }
                `;

                let fragment = `
                    varying vec2 vUv;
                    uniform float dispFactor;
                    uniform sampler2D disp;
                    uniform sampler2D currentImage;
                    uniform sampler2D nextImage;
                    uniform float angle1;
                    uniform float angle2;
                    uniform float intensity1;
                    uniform float intensity2;
            
                    mat2 getRotM(float angle) {
                        float s = sin(angle);
                        float c = cos(angle);
                        return mat2(c, -s, s, c);
                    }
            
                    void main() {
                        vec2 uv = vUv;
                        vec4 disp = texture2D(disp, vUv);
                        vec2 dispVec = vec2(disp.r, disp.g);
            
                        float intensity = 0.3;
            
                        vec2 distortedPosition1 = vUv + getRotM(angle1) * dispVec * intensity1 * dispFactor;
                        vec2 distortedPosition2 = vUv + getRotM(angle2) * dispVec * intensity2 * (1.0 - dispFactor);
                        vec4 _currentImage = texture2D(currentImage, distortedPosition1);
                        vec4 _nextImage = texture2D(nextImage, distortedPosition2);
                        gl_FragColor = mix(_currentImage, _nextImage, dispFactor);
                    }
                `;

                function firstDefined() {
                    for (var i = 0; i < arguments.length; i++) {
                        if (arguments[i] !== undefined) return arguments[i];
                    }
                }

                let images = opts.images, image, sliderImages = [];
                let placeholder = opts.placeholder;
                let canvasWidth = placeholder.clientWidth;
                let canvasHeight = placeholder.clientHeight;
                let parent = opts.parent;
                let renderWidth = canvasWidth;
                let renderHeight = canvasHeight;
                let renderW, renderH;

                let dispImage = opts.displacementImage;
                let dispIsRandom = opts.isRandom;
                let intensity1 = firstDefined(opts.intensity1, opts.intensity, 1);
                let intensity2 = firstDefined(opts.intensity2, opts.intensity, 1);
                let commonAngle = firstDefined(opts.angle, Math.PI / 4);
                let angle1 = firstDefined(opts.angle1, commonAngle);
                let angle2 = firstDefined(opts.angle2, -commonAngle * 3);
                let speedIn = firstDefined(opts.speedIn, opts.speed, 1.6);
                let speedOut = firstDefined(opts.speedOut, opts.speed, 1.2);
                let easing = firstDefined(opts.easing, Expo.easeOut);

                if (renderWidth > canvasWidth) {
                    renderW = renderWidth;
                } else {
                    renderW = canvasWidth;
                }

                renderH = canvasHeight;

                let renderer = new THREE.WebGLRenderer({
                    antialias: false,
                });

                renderer.setPixelRatio(window.devicePixelRatio);
                renderer.setClearColor(0x57b5be, 1.0);
                renderer.setSize(renderW, renderH);
                parent.appendChild(renderer.domElement);

                let loader = new THREE.TextureLoader();
                loader.crossOrigin = "anonymous";

                images.forEach((img) => {

                    image = loader.load(img.getAttribute('src'), function (texture) {
                        texture.wrapS = THREE.ClampToEdgeWrapping;
                        texture.wrapT = THREE.ClampToEdgeWrapping;
                        texture.minFilter = THREE.LinearFilter;
                        mat.map = texture;
                        render();
                    });
                    image.magFilter = image.minFilter = THREE.LinearFilter;
                    image.anisotropy = renderer.capabilities.getMaxAnisotropy();
                    sliderImages.push(image);

                });

                var disp = loader.load(dispImage, render);
                disp.wrapS = disp.wrapT = THREE.RepeatWrapping;

                let scene = new THREE.Scene();
                scene.background = new THREE.Color(0xf9f8f3);
                let camera = new THREE.OrthographicCamera(
                    renderWidth / -2,
                    renderWidth / 2,
                    renderHeight / 2,
                    renderHeight / -2,
                    1,
                    1000
                );

                camera.position.z = 1;

                let mat = new THREE.ShaderMaterial({
                    uniforms: {
                        intensity1: { type: 'f', value: intensity1 },
                        intensity2: { type: 'f', value: intensity2 },
                        dispFactor: { type: "f", value: 0.0 },
                        angle1: { type: 'f', value: angle1 },
                        angle2: { type: 'f', value: angle2 },
                        currentImage: { type: "t", value: sliderImages[0] },
                        nextImage: { type: "t", value: sliderImages[1] },
                        disp: { type: 't', value: disp },
                    },
                    vertexShader: vertex,
                    fragmentShader: fragment,
                    transparent: true,
                    opacity: 1.0
                });

                let geometry = new THREE.PlaneBufferGeometry(renderWidth, renderHeight, 1);
                let object = new THREE.Mesh(geometry, mat);
                object.position.set(0, 0, 0);
                scene.add(object);

                function resize() {
                    const canvas = renderer.domElement
                    const width = canvas.clientWidth;
                    const height = canvas.clientHeight;
                    if (canvas.width !== width || canvas.height !== height) {
                        renderer.setSize(width, height, false);
                    }
                }

                function render() {
                    resize();

                    if (mat.map == undefined || !mat.map.image) {
                        return;
                    }

                    const canvas = renderer.domElement;
                    const image = mat.map.image;
                    const canvasAspect = canvas.clientWidth / canvas.clientHeight;
                    const imageAspect = image.width / image.height;

                    let horizontalDrawAspect = imageAspect / canvasAspect;
                    let verticalDrawAspect = 1;

                    if (horizontalDrawAspect < 1) {
                        verticalDrawAspect /= horizontalDrawAspect;
                        horizontalDrawAspect = 1;
                    }

                    object.scale.x = horizontalDrawAspect;
                    object.scale.y = verticalDrawAspect;


                    renderer.render(scene, camera);
                }


                heroSwiper.on('slideChange', function () {

                    let isAnimating = false;

                    if (!isAnimating) {

                        isAnimating = true;

                        let slideId = parseInt(heroSwiper.activeIndex, 10);

                        mat.uniforms.nextImage.value = sliderImages[slideId];
                        mat.uniforms.nextImage.needsUpdate = true;



                        TweenLite.to(mat.uniforms.dispFactor, speedIn, {
                            value: 1,
                            ease: easing,
                            onComplete: function () {
                                mat.uniforms.currentImage.value = sliderImages[slideId];
                                mat.uniforms.currentImage.needsUpdate = true;
                                mat.uniforms.dispFactor.value = 0.0;
                                isAnimating = false;

                                if (dispIsRandom) {
                                    var random = Math.floor(Math.random() * 16) + 1;
                                    var currentDisplacementImage = localize.themeurl + '/assets/img/effect/' + random + '.jpg';
                                    var disp = loader.load(currentDisplacementImage, render);
                                    disp.wrapS = disp.wrapT = THREE.RepeatWrapping;
                                    mat.uniforms.disp.value = disp;
                                }
                            }
                        })

                    }

                });



                window.addEventListener('resize', function (e) {
                    let canvasWidth = placeholder.clientWidth;
                    let canvasHeight = placeholder.clientHeight;
                    let renderWidth = canvasWidth;
                    let renderHeight = renderHeight;

                    let renderW, renderH;

                    if (renderWidth > canvasWidth) {
                        renderW = renderWidth;
                    } else {
                        renderW = canvasWidth;
                    }

                    renderH = canvasHeight;
                    renderer.setSize(renderW, renderH);
                });

                let animate = function () {
                    requestAnimationFrame(animate);

                    renderer.render(scene, camera);
                };
                animate();
            };



            var theSlider = document.getElementById('slider');

            imagesLoaded(document.querySelectorAll('img.js-shader-image'), () => {

                theSlider.classList.remove('loading');

                if (theSlider != null) {
                    const imgs = Array.from(theSlider.querySelectorAll('img.js-shader-image'));
                    var random = Math.floor(Math.random() * 16) + 1;
                    var currentDisplacementImage = theSlider.dataset.displacement;
                    var currentIsRandom = false;
                    if (theSlider.dataset.displacement == "random") {
                        currentIsRandom = true;

                        currentDisplacementImage = localize.themeurl + '/assets/img/effect/' + random + '.jpg';
                    }
                    new displacementSlider({
                        parent: theSlider,
                        intensity: theSlider.dataset.intensity || undefined,
                        intensity1: theSlider.dataset.intensity1 || undefined,
                        intensity2: theSlider.dataset.intensity2 || undefined,
                        speedIn: theSlider.dataset.speedin || undefined,
                        speedOut: theSlider.dataset.speedOut || undefined,
                        easing: theSlider.dataset.easing || undefined,
                        images: imgs,
                        placeholder: theSlider.querySelectorAll('img.js-shader-image')[0],
                        displacementImage: currentDisplacementImage,
                        isRandom: currentIsRandom
                    });
                }

            });


        }
    });
})(jQuery);
